<template>
  <portal to="modal-target">
    <!-- モーダル部分始まり -->
    <bs-modal
      id="edit"
      show-header
      dialog-centered
      :confirm-close="
        is_validated ? '修正依頼を送信していませんが、よろしいでしょうか？' : ''
      "
    >
      <template slot="modal-title">
        <h5 class="modal-title">お届け先修正依頼</h5>
      </template>

      <p class="text-center">
        お届け先を修正し「確認」後　「修正依頼送信」を押下してください。
      </p>
      <table class="table table-bordered tbl_edit01">
        <tbody>
          <tr>
            <th class="bg-tbl-light">お届け先名</th>
            <td>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': edit_error.ngfg_dlCompanyNa }"
                v-model="dlcompany_na"
                :disabled="is_validated"
              />
              <div class="invalid-feedback" v-if="edit_error.ngfg_dlCompanyNa">
                {{ edit_error.msg_dlCompanyNa }}
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-tbl-light">お届け先支店名</th>
            <td>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': edit_error.ngfg_dlCompanySubNa }"
                v-model="dlcompanysub_na"
                :disabled="is_validated"
              />
              <div
                class="invalid-feedback"
                v-if="edit_error.ngfg_dlCompanySubNa"
              >
                {{ edit_error.msg_dlCompanySubNa }}
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-tbl-light">お届け先ｶﾅ</th>
            <td>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': edit_error.ngfg_dlCompanyKanaNa }"
                v-model="dlcompanykana_na"
                :disabled="is_validated"
              />
              <div
                class="invalid-feedback"
                v-if="edit_error.ngfg_dlCompanyKanaNa"
              >
                {{ edit_error.msg_dlCompanyKanaNa }}
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-tbl-light">郵便番号</th>
            <td>
              <input
                type="tel"
                class="form-control zip ml-0 is-auto-width"
                :class="{ 'is-invalid': edit_error.ngfg_dlPostCd }"
                maxlength="7"
                v-model="dlpost_cd"
                :disabled="is_validated"
                @input="is_edited = true"
              />*数字のみ入力下さい
              <div class="invalid-feedback" v-if="edit_error.ngfg_dlPostCd">
                {{ edit_error.msg_dlPostCd }}
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-tbl-light">住所</th>
            <td>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': edit_error.ngfg_dlAddressNa }"
                v-model="dladdress_na"
                :disabled="is_validated"
              />
              <div class="invalid-feedback" v-if="edit_error.ngfg_dlAddressNa">
                {{ edit_error.msg_dlAddressNa }}
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-tbl-light">TEL</th>
            <td>
              <input
                type="tel"
                class="form-control tel ml-0 is-auto-width"
                :class="{ 'is-invalid': edit_error.ngfg_dlTelNo }"
                v-model="dltel_no"
                :disabled="is_validated"
              />*数字のみ入力下さい
              <div class="invalid-feedback" v-if="edit_error.ngfg_dlTelNo">
                {{ edit_error.msg_dlTelNo }}
              </div>
            </td>
          </tr>
          <tr>
            <th class="bg-tbl-light">FAX</th>
            <td>
              <input
                type="tel"
                class="form-control tel ml-0 is-auto-width"
                :class="{ 'is-invalid': edit_error.ngfg_dlFaxNo }"
                v-model="dlfax_no"
                :disabled="is_validated"
              />*数字のみ入力下さい
              <div class="invalid-feedback" v-if="edit_error.ngfg_dlFaxNo">
                {{ edit_error.msg_dlFaxNo }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="err_edit">
            <i></i>修正内容が既存データと同じです。修正してください
          </div> -->
      <div class="alert alert-danger mt-3" v-if="edit_error.message">
        {{ edit_error.message }}
      </div>
      <template v-if="isEditable">
        <div class="btn_edit mt20" v-if="!is_validated">
          <button class="btn btn-secondary" @click="closeEditModalHandler">
            閉じる
          </button>
          <button
            class="btn btn-primary"
            @click="checkDeliveryInfoHandler"
            :disabled="is_validated"
          >
            確認
          </button>
        </div>
        <div class="alert alert-success mt-3" v-if="is_validated">
          こちらの内容でよろしければ「修正依頼送信」を押下してください。
        </div>
        <div class="btn_edit mt20">
          <button
            class="btn btn-primary"
            @click="backDeliveryInfoHandler"
            :disabled="!is_validated"
            v-if="is_validated"
          >
            修正へ
          </button>
          <button
            class="btn btn-order02"
            :disabled="!is_validated"
            @click="editDeliveryInfoHandler"
            v-if="is_validated"
          >
            修正依頼送信
          </button>
        </div>
      </template>
    </bs-modal>
    <!-- モーダル部分終わり -->
  </portal>
</template>

<script>
export default {
  props: {
    deliveryData: { type: Object, required: true }
  },
  data() {
    return {
      // Edit Info
      delivery_cd: "",
      dlcompany_na: "",
      dlcompanysub_na: "",
      dlcompanykana_na: "",
      dlpost_cd: "",
      dladdress_na: "",
      dltel_no: "",
      dlfax_no: "",

      edit_error: {},
      is_edited: false,
      is_validated: false
    };
  },
  computed: {
    isEditable() {
      return (
        this.deliveryData.modify_fg != 1 &&
        this.deliveryData.modify_fg != 9 &&
        this.deliveryData.new_fg != 1
      );
    }
  },
  watch: {
    deliveryData: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init() {
      this.delivery_cd = this.deliveryData.delivery_cd;
      this.dlcompany_na = this.deliveryData.dlcompany_na;
      this.dlcompanysub_na = this.deliveryData.dlcompanysub_na;
      this.dlcompanykana_na = this.deliveryData.dlcompanykana_na;
      this.dlpost_cd = this.deliveryData.dlpost_cd;
      this.dladdress_na = this.deliveryData.dladdress_na;
      this.dltel_no = this.deliveryData.dltel_no;
      this.dlfax_no = this.deliveryData.dlfax_no;
      this.is_validated = false;

      if (this.deliveryData.modify_fg == 1) {
        this.edit_error = {
          message: "指定されたお届け先は既に修正依頼されています。"
        };
      } else if (this.deliveryData.modify_fg == 9) {
        this.edit_error = {
          message: "指定されたお届け先は既に削除依頼されています。"
        };
      } else if (this.deliveryData.new_fg == 1) {
        this.edit_error = {
          message: "指定されたお届け先は新規登録依頼中です。"
        };
      } else {
        this.edit_error = {};
      }

      this.$bootstrap.showModal("edit");
    },
    async checkDeliveryInfoHandler() {
      this.edit_error = {};
      this.is_validated = false;

      if (!this.checkEditedDeliveryInfoHandler()) {
        this.edit_error = {
          message:
            "お届け先情報が修正されていません。修正後に確認ボタンを押してください。"
        };
        return;
      }

      const response = await this.postAsteria(
        "CommonAPI",
        "checkDeliveryInfo_req",
        {
          delivery_cd: this.delivery_cd,
          dlcompany_na: this.dlcompany_na,
          dlcompanysub_na: this.dlcompanysub_na,
          dlcompanykana_na: this.dlcompanykana_na,
          dlpost_cd: this.dlpost_cd,
          dladdress_na: this.dladdress_na,
          dltel_no: this.dltel_no,
          dlfax_no: this.dlfax_no
        }
      );

      if (response.responseData.return != 0) {
        this.edit_error = response.responseData;
        return;
      }

      this.is_validated = true;
    },

    checkEditedDeliveryInfoHandler() {
      return (
        !this.$utility.compare(
          this.dlcompany_na,
          this.deliveryData.dlcompany_na
        ) ||
        !this.$utility.compare(
          this.dlcompanysub_na,
          this.deliveryData.dlcompanysub_na
        ) ||
        !this.$utility.compare(
          this.dlcompanykana_na,
          this.deliveryData.dlcompanykana_na
        ) ||
        !this.$utility.compare(this.dlpost_cd, this.deliveryData.dlpost_cd) ||
        !this.$utility.compare(
          this.dladdress_na,
          this.deliveryData.dladdress_na
        ) ||
        !this.$utility.compare(this.dltel_no, this.deliveryData.dltel_no) ||
        !this.$utility.compare(this.dlfax_no, this.deliveryData.dlfax_no)
      );
    },

    backDeliveryInfoHandler() {
      this.edit_error = {};
      this.is_validated = false;
    },

    async editDeliveryInfoHandler() {
      if (!this.is_validated) {
        return;
      }

      const response = await this.postAsteria(
        "CommonAPI",
        "editDeliveryInfo_req",
        {
          delivery_cd: this.delivery_cd,
          dlcompany_na: this.dlcompany_na,
          dlcompanysub_na: this.dlcompanysub_na,
          dlcompanykana_na: this.dlcompanykana_na,
          dlpost_cd: this.dlpost_cd,
          dladdress_na: this.dladdress_na,
          dltel_no: this.dltel_no,
          dlfax_no: this.dlfax_no
        }
      );

      if (response.responseData.return != 0) {
        if (response.responseData.return != 9) {
          window.alert("お届け先修正依頼の送信に失敗しました");
        }
        return;
      }

      window.alert(
        "お届け先依頼送信が完了しました。\n\n※画面のお届け先は翌日以降に反映されます。\nしばらくお待ちください。"
      );
      this.is_validated = false;

      this.$emit(
        "edited",
        this.getAsteriaArray(response.responseData, "deliveryData")
      );
      this.closeEditModalHandler();
    },

    closeEditModalHandler() {
      if (this.is_validated) {
        if (
          !window.confirm("修正依頼を送信していませんが、よろしいでしょうか？")
        ) {
          return;
        }
      }

      this.$bootstrap.hideModal("edit");
      this.$emit("close");
    }
  }
};
</script>
